import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import WrappedTextField from 'components/WrappedTextField/WrappedTextField';
import ORTypography from 'components/ORTypography/ORTypography';
import { required, maxLength } from 'services/validationMsgs';

const maxLength128 = maxLength(128);

const useStyles = makeStyles((theme) => ({
  stepFourField: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  infoText: {
    display: 'flex',
    fontSize: '.8571rem',
    color: theme.customColors.mediumGrey,
  },
  infoIcon: {
    fontSize: '1.14285rem',
    marginTop: theme.spacing(0.25),
    marginRight: theme.spacing(0.5),
  },
}));

export function UnstyledStepFour() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <ORTypography className={classes.infoText}>
        <InfoOutlinedIcon className={classes.infoIcon} />
        <em>The instance name cannot be changed afterwards.</em>
      </ORTypography>

      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Field
          className={classes.stepFourField}
          name="name"
          label="Name"
          variant="outlined"
          validate={[maxLength128, required]}
          component={WrappedTextField}
        />
      </form>
    </React.Fragment>
  );
}

export default reduxForm({
  form: 'create',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(UnstyledStepFour);
